export const TOGGLE_SELECTED = "TOGGLE_SELECTED";
export const SET_SHOW_BULK_OPTIONS = "SET_SHOW_BULK_OPTIONS";
export const CHANGE_SORT_OPTION = "CHANGE_SORT_OPTION";
export const CHANGE_CHANNEL = "CHANGE_CHANNEL";
export const CHANGE_MEDIA = "CHANGE_MEDIA";
export const CHANGE_SENTIMENT = "CHANGE_SENTIMENT";
export const CHANGE_INFLUENCER_TYPE = "CHANGE_INFLUENCER_TYPE";
export const CHANGE_SENTIMENT_TYPE = "CHANGE_SENTIMENT_TYPE";
export const CHANGE_GROUPING = "CHANGE_GROUPING";
export const CHANGE_POST_TYPE = "CHANGE_POST_TYPE";
export const TOGGLE_SELECT_ALL = "TOGGLE_SELECT_ALL";
export const TOGGLE_TO_DESELECT = "TOGGLE_TO_DESELECT";
export const CHANGE_SAMPLING = "CHANGE_SAMPLING";
export const CHANGE_EXCLUSION = "CHANGE_EXCLUSION";
export const RESET_REFINE_FILTER_OPTIONS = "RESET_REFINE_FILTER_OPTIONS";
export const RESET_ALL_EXCEPT_ADDTIONALPARAM = "RESET_ALL_EXCEPT_ADDTIONALPARAM";

export function toggleSelected(id) {
    return {
        type: TOGGLE_SELECTED,
        payload: id,
    };
}

export function toggleToDeselect(id) {
    return {
        type: TOGGLE_TO_DESELECT,
        payload: id,
    };
}

export function toggleShowBulkOptions() {
    return {
        type: SET_SHOW_BULK_OPTIONS,
    };
}

export function sortOptionChange(value) {
    return {
        type: CHANGE_SORT_OPTION,
        payload: value,
    };
}

export function setChannel(val) {
    return {
        type: CHANGE_CHANNEL,
        payload: val,
    };
}

export function setExclusion(val) {
    return {
        type: CHANGE_EXCLUSION,
        payload: val,
    };
}

export function setMedia(val) {
    return {
        type: CHANGE_MEDIA,
        payload: val,
    };
}

export function setSentiment(val) {
    return {
        type: CHANGE_SENTIMENT,
        payload: val,
    };
}

export function setInfluencers(val) {
    return {
        type: CHANGE_INFLUENCER_TYPE,
        payload: val,
    };
}

export function setGrouping(val) {
    return {
        type: CHANGE_GROUPING,
        payload: val,
    };
}

export function setPostType(val) {
    return {
        type: CHANGE_POST_TYPE,
        payload: val,
    };
}

export function setSentimentType(val) {
    return {
        type: CHANGE_SENTIMENT_TYPE,
        payload: val,
    };
}

export function setSampling(val) {
    return {
        type: CHANGE_SAMPLING,
        payload: val,
    };
}

export function toggleSelectAll(val) {
    return {
        type: TOGGLE_SELECT_ALL,
        payload: val,
    };
}

export function resetAllRefineOptions() {
    return {
        type: RESET_REFINE_FILTER_OPTIONS,
    };
}

export function resetAllRefineOptionsExceptParam(val) {
    return {
        type: RESET_ALL_EXCEPT_ADDTIONALPARAM,
        payload: val,
    };
}
